import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { OuiTagModule } from 'omnium-ui/tag';

export type ConsultantTagStatus = 'completed' | 'in-progress' | 'todo' | 'error' | 'to-correct' | 'transition' | 'pending';

const CONSULTANT_STATUS_LABELS: Record<string, string> = {
  '0': 'Consultant prospect',
  '1': 'Affilié',
  '2': 'Résilié',
  '3': 'Radié',
  '4': 'Apprenti',
  '5': 'Apprenti prospect',
  '6': 'Apprenti résilié',
};

export function getConsultantStatusLabel(statusCode: string | number | null | undefined): string {
  const normalized = statusCode?.toString().trim();
  return normalized ? CONSULTANT_STATUS_LABELS[normalized] ?? normalized : 'Statut inconnu';
}

@Component({
  selector: 'dbw-consultant-status-tag',
  imports: [OuiTagModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <oui-tag
      type="status"
      size="big"
      [status]="tagStatus()">
      {{ label() }}
    </oui-tag>
  `,
})
export class ConsultantStatusTagComponent {
  readonly statusCode = input<string | number | null | undefined>(undefined);

  protected readonly label = computed(() => getConsultantStatusLabel(this.statusCode()));

  protected readonly tagStatus = computed<ConsultantTagStatus>(() => {
    switch (this.statusCode()?.toString().trim()) {
      case '1':
        return 'completed';
      case '4':
        return 'in-progress';
      case '0':
      case '5':
        return 'transition';
      case '2':
      case '6':
        return 'pending';
      case '3':
        return 'error';
      default:
        return 'pending';
    }
  });
}
